import React from "react";
import Marquee from "react-fast-marquee";

export default function TickerTape({ tickers = [] }) {
  if (!tickers.length) {
    return (
      <div className="bg-black border-y border-white/10 h-10 flex items-center px-4">
        <span className="overline">awaiting market data...</span>
      </div>
    );
  }
  return (
    <div className="bg-black border-y border-white/10 h-10 flex items-center" data-testid="ticker-tape">
      <Marquee speed={36} gradient={false} pauseOnHover>
        {tickers.map((t, i) => {
          const up = (t.change_pct || 0) >= 0;
          const c = up ? "#34C759" : "#FF3B30";
          return (
            <div key={i} className="flex items-center gap-3 px-6 border-r border-white/5" data-testid={`ticker-${t.symbol}`}>
              <span className="mono text-xs text-white/70">{t.name}</span>
              <span className="mono text-sm">{t.price?.toFixed(2)}</span>
              <span className="mono text-xs" style={{ color: c }}>
                {up ? "▲" : "▼"} {Math.abs(t.change_pct || 0).toFixed(2)}%
              </span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
}
